import './VendorLogin.css';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Button, CircularProgress, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Logo from '../../img/final_logo.png';

function VendorLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [phoneNo, setPhoneNo] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phoneNo || !password) {
      enqueueSnackbar('Please fill all the details !!!', { variant: 'error' });
      return;
    }
    setLoading(true);
    const body = { phone_no: phoneNo, password };
    try {
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/user/vendorlogin`, body);
      if (res.data.success) {
        const vendorData = { ...res.data.vendor, isVendor: true };
        sessionStorage.setItem('ID_CardAdmin_user', JSON.stringify(vendorData));
        sessionStorage.setItem('ID_CardAdmin_user_auth', CryptoJS.AES.encrypt('true', process.env.REACT_APP_CRYPTO_JS_SECRET).toString());
        sessionStorage.setItem('ID_CardAdmin_user_role', 'vendor');
        // After vendor login, redirect to the school‑setup form
        navigate('/school-setup');
        enqueueSnackbar('Login Successful !!!', { variant: 'success' });
      } else {
        enqueueSnackbar(res.data.message || 'Login failed', { variant: 'error' });
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Error, please try again !!!', { variant: 'error' });
    }
    setLoading(false);
  };

  return (
    <div id="login">
      <img className="sidemenu_logo" style={{ width: '200px' }} src={Logo} alt="logo" />
      <form className="login_form" onSubmit={handleSubmit}>
        <FormControl variant="outlined" fullWidth sx={{ marginBottom: 2 }}>
          <InputLabel htmlFor="vendor-phone">Phone Number</InputLabel>
          <OutlinedInput
            id="vendor-phone"
            type="tel"
            label="Phone Number"
            value={phoneNo}
            onChange={(e) => setPhoneNo(e.target.value)}
          />
        </FormControl>
        <FormControl variant="outlined" fullWidth sx={{ marginBottom: 2 }}>
          <InputLabel htmlFor="vendor-password">Password</InputLabel>
          <OutlinedInput
            id="vendor-password"
            type={showPassword ? 'text' : 'password'}
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <Button
          size="large"
          variant="contained"
          type="submit"
          fullWidth
          disabled={loading}
          sx={{ backgroundColor: '#4b49ac !important', marginTop: 3.5 }}
        >
          {!loading ? 'Login' : <CircularProgress size={27} sx={{ color: '#fff' }} />}
        </Button>
      </form>
    </div>
  );
}

export default VendorLogin;
